import { makeStyles,useTheme } from '@material-ui/core/styles';
import theme from 'theme';

const useStyles = makeStyles(theme=>({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',

    },
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  table: {
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'auto',
      behavior: 'smooth' ,
      display: 'block',
      width: '100%',
    }
  },
  iconButton: {
    padding: '5px 0px 5px 14px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase'
  },
  productCodeCell: {
    width: '80px',
    paddingLeft: '20px'
  },
  unitCell: {
    alignItems: 'center',
    width: '320px',
    paddingLeft: '20px',
    wordWrap: 'break-word',
    paddingRight: '20px'
  },

  closeIcon: {
    fontSize: '21px'
  },
  activityTypeCell: {
    width: '110px',
    paddingLeft: '20px'
  },
  startTimeCell: {
    width: '170px',
    paddingLeft: '20px'
  },
  durationCell: {
    width: '150px',
    paddingLeft: '20px'
  },
  participantsCell: {
    width: '170px',
    paddingLeft: '20px'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  }
}));

export default useStyles;
